import { createFileRoute, redirect } from '@tanstack/react-router';

import { useAuth } from '@/store/auth';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const session = useAuth.getState().session;
    throw redirect({ to: session ? '/dashboard' : '/login' });
  },
  component: () => null,
});
